<template>
    <div class="retr__content">
        <!-- Manufacturer rows -->
        <retr-current-manufacturer-row
            v-for="(manufacturer, index) in retr.list"
            :key="`manufacturer-${manufacturer.manufacturer_id}-${index}`"
            :ref="`manufacturer-${index}`"
            :manufacturer="manufacturer"
        />
    </div>
</template>

<script>
import RetrCurrentManufacturerRow from '@/components/my-business/retr/RetrCurrentManufacturerRow.vue'

export default {
    name: 'RetrCurrentSingleTable',
    components: {
        RetrCurrentManufacturerRow
    },
    props: {
        retr: {
            type: Object,
            required: true,
            validator: (value) => {
                return value && Array.isArray(value.list)
            }
        },
        selectedManufacturerName: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            expandTimeout: null
        }
    },
    beforeDestroy() {
        if (this.expandTimeout) {
            clearTimeout(this.expandTimeout)
        }
    },
    methods: {
        /**
         * Trigger auto-expand for matching manufacturer
         * Called from parent RetrCurrentList
         *
         * Note: Safe null-check on manufacturer_name to prevent errors
         * when manufacturer doesn't have a name (flat display mode)
         */
        triggerAutoExpand() {
            if (!this.selectedManufacturerName || !this.retr.list) {
                return
            }

            // Clear any pending expand timeout to prevent memory leaks
            if (this.expandTimeout) {
                clearTimeout(this.expandTimeout)
            }

            // Find matching manufacturer and expand it
            this.retr.list.forEach((manufacturer, index) => {
                // Safe check: only proceed if manufacturer_name exists
                if (manufacturer.manufacturer_name &&
                    manufacturer.manufacturer_name.toLowerCase() === this.selectedManufacturerName.toLowerCase()) {
                    const refKey = `manufacturer-${index}`
                    const manufacturerComponent = this.$refs[refKey]

                    if (manufacturerComponent && manufacturerComponent[0]) {
                        // Delay matches CSS transition duration for smooth animation
                        this.expandTimeout = setTimeout(() => {
                            if (manufacturerComponent && manufacturerComponent[0]) {
                                manufacturerComponent[0].expandRow()
                            }
                        }, 300)
                    }
                }
            })
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/components/retr-common';
</style>